let language = {
    "LBL_HOME":"Home",
    "LBL_BUDGETS": "Budgets",
    "LBL_VIEW_BUDGETS": "View Application Budgets",
    "LBL_ADD_BUDGETS": "Create Budgets",
    "LBL_BUDGET_REVIEWS": "Budget Reviews",    
    "LBL_SERIAL_NO":"S.No",
    "LBL_BT_NAME":"Study Budget Name",
    "LBL_CR_MULTIPIER":"Currency Multiplier",
    "LBL_PROJECT_NAME":"Project Name",
    "LBL_OPPORT_NAME":"Opportunity Name",
    "LBL_APP_NAME":"Application Name",
    "LBL_STRATEGIC_PRIORITY":"Strategic Priority",
    "LBL_RELATED_APP_OPP":"Related Application & Opportunity",
    "LBL_APP_TITLE":"Application Title",
    "LBL_PROGRAM":"Program",
    "LBL_STATUS":"Status",
    "LBL_STAGE":"Stage",
    "LBL_OPPORT_TITLE":"Opportunity Title",
    "LBL_FUNDER":"Funder",
    "LBL_EXPT_BUDGET":"Budget Cap",
    "LBL_DEADLINE":"Application Deadline",
    "LBL_APPLICATION_BY":"App Owner",
    "LBL_OPPORTUNITY_BY":"Opportunity Owner",
    "LBL_ITEMS":"Items",
    "LBL_UNITS":"Units",
    "LBL_MONTHS":"Month",
    "LBL_PERCENT_OF_TIME":"% of Time",
    "LBL_COST_PER_MONTH":"Cost/Month",
    "LBL_YEAR1":"Year 1",
    "LBL_YEAR2":"Year 2",
    "LBL_YEAR3":"Year 3",
    "LBL_YEAR4":"Year 4",
    "LBL_YEAR5":"Year 5",
    "LBL_YEAR6":"Year 6",
    "LBL_YEAR7":"Year 7",
    "LBL_YEAR8":"Year 8",
    "LBL_YEAR9":"Year 9",
    "LBL_YEAR10":"Year 10",
    "LBL_TOTAL_INR":"Total INR",
    "LBL_TOTAL_USD":"Total Ot.Curr",
    "LBL_NOTES":"Notes",
    "LBL_APP_BUDGET_STATUS":"App. Budget Status",
    "LBL_MARK_APPROVED":"Action",
    "LBL_PI_NAME":"PI Name",
}

export default language;